<template lang="pug">
  div.page--cart.page
    page-header.page-header--account(
      :breadcrumb-only="true"
      header-class="page-header--cart page-header--small"
      header-background="/img/frontend/page/page-header-default-background.jpg"
    )
    .container.my-lg-5.my-3
      .row
        .col-lg-8
          .row
            .col
              p(v-if="!cart.id || cart.data.items.length === 0") {{ trans('labels.frontend.cart.no-item') }}
              .table-cart-container(v-if="cart.id && cart.data.items.length > 0")
                table.table.table-cart
                  thead
                    tr.d-lg-table-row.d-none
                      th.table-cart__title {{ trans('labels.frontend.cart.cart') }}
                      th {{ trans('labels.frontend.cart.table.item') }}
                      th {{ trans('labels.frontend.cart.table.qty') }}
                      th.text-right {{ trans('labels.frontend.cart.table.total') }}
                    tr.d-lg-none.d-table-row
                      th(colspan="3") {{ trans('labels.frontend.cart.table.item') }}
                      th.text-right {{ trans('labels.frontend.cart.table.total') }}
                  tbody
                    tr(v-for="item in cart.data.items" :key="item.id")
                      td.table-cart__item-thumbnail-cell
                        router-link(v-if="item.item_code" :to="item.permalink")
                          img.table-cart__item-thumbnail(
                            :src="'https://www.sparkinter.com/imageproduct/' + item.item_code + '.jpg'"
                            v-if="item.item_code"
                          )
                      td.px-3.px-lg-0
                        router-link(v-if="item.item_code" :to="item.permalink")
                          h4.table-cart__item-title {{ item.name }}
                        p.table-cart__item-meta
                          | {{ trans('labels.frontend.product-list.price') }}:
                          span.table-cart__item-price ฿ {{ (item.sale_price ? item.sale_price : item.price) | numeral }}
                        .quantity-box.d-flex.d-lg-none
                          button.quantity-box__button.quantity-box__button--minus(
                            type='button' @click.prevent="onQtyMinus(item)" :disabled="item.isRefreshing || item.quantity === 1 || item.quantity === item.unit_factor"
                          ) -
                          input.quantity-box__input(type='number', :min='item.unit_factor', :step='item.unit_factor', :placeholder='item.unit_factor' :readonly="item.unit_factor > 1" v-model="item.quantity" @blur="onBlur(item)" @focus="onFocus(item)")
                          button.quantity-box__button.quantity-box__button--plus(type='button' @click.prevent="onQtyPlus(item)" :disabled="item.isRefreshing") +
                      td.d-lg-table-cell.d-none
                        .quantity-box
                          button.quantity-box__button.quantity-box__button--minus(
                            type='button' @click.prevent="onQtyMinus(item)" :disabled="item.isRefreshing || item.quantity === 1 || item.quantity === item.unit_factor"
                            ) -
                          input.quantity-box__input(type='number', :min='item.unit_factor', :step='item.unit_factor', :placeholder='item.unit_factor' :readonly="item.unit_factor > 1" v-model="item.quantity" @blur="onBlur(item)" @focus="onFocus(item)")
                          button.quantity-box__button.quantity-box__button--plus(type='button' @click.prevent="onQtyPlus(item)" :disabled="item.isRefreshing") +
                      td.table-cart__item-total-cell.text-right(colspan="2" width="200px")
                        span.table-cart__item-tota(v-if="item.isRefreshing")
                          font-awesome-icon(:icon=['far', 'circle-notch'] spin)
                        span.table-cart__item-total(v-if="!item.isRefreshing")
                          | ฿ {{ item.quantity * (item.sale_price ? item.sale_price : item.price) | numeral }}
                        div.table-cart__item-actions
                          add-to-wishlist-button.d-inline-block(:item-code="item.item_code" v-if="item.item_code")
                          font-awesome-icon(:icon=['far', 'trash-alt'] @click.prevent="onRemove(item)").table-cart__item-remove
          .row
            .col
              p.mb-lg-0.mb-3
                | {{ trans('labels.frontend.cart.table.continue-shopping') }}
                router-link.btn.btn-primary.btn-outline.btn-sm.ml-2(to='/', :title="trans('labels.frontend.cart.table.shop-now')") {{ trans('labels.frontend.cart.table.shop-now') }}
        .col-lg-4
          .cart-summary
            .cart-summary__body
              h3.cart-summary__title Summary
              .cart-coupon
                .cart-coupon__input-group
                  input.cart-coupon__input-box(type='text', :placeholder="trans('labels.frontend.cart.table.coupon')", name='coupon' v-model="cart.coupon_code")
                  button.cart-coupon__submit-button(type='button' @click.prevent="onApplyCouponCode") {{ trans('labels.frontend.cart.table.use_coupon') }}
              table.table.cart-summary__table
                tbody
                  tr
                    td {{ trans('labels.frontend.cart.table.sub_total_vat_incl') }}
                    td.text-right ฿ {{ $store.getters['cart/totals'] | numeral }}
                  tr(v-if="$store.getters['cart/coupon'] && $store.getters['cart/coupon'].id")
                    td {{ trans('labels.frontend.cart.table.discount') }} ({{ $store.getters['cart/coupon'].code }})
                    td.text-right
                      strong.text-primary - ฿ {{ $store.getters['cart/total_discount'] | numeral }}
                  tr
                    td {{ trans('labels.frontend.cart.table.shipping_fees') }}
                    td.text-right {{ trans('labels.frontend.cart.table.na') }}
                  tr
                    td
                      strong {{ trans('labels.frontend.cart.table.net_total') }}
                    td.text-right ฿ {{ ( $store.getters['cart/totals'] - $store.getters['cart/total_discount'] ) | numeral }}
            .cart-summary__body
              .alert-notification.alert-notification--warning.mb-3(v-if="parseFloat($store.getters['cart/totals']) < 100" style="background-color: #eee")
                | {{ trans('labels.frontend.payment.minimum_order_value') }}
              button.btn.btn-primary.btn-block.btn-lg(
                :disabled="!cart || parseFloat($store.getters['cart/totals']) < 100"
                @click.prevent="onCheckout" :title="trans('labels.frontend.cart.table.checkout')"
              ) {{ trans('labels.frontend.cart.table.checkout') }}
</template>

<script>
import BreadcrumbsManager from '../../../mixins/BreadcrumbsManager';
import PageHeader from '../../../components/layouts/PageHeader.vue';
import router from '../../../routes';
import notify from '../../../components/notify';
import AddToWishlistButton from '../../../components/buttons/shop/AddToWishlistButton.vue';

export default {
  components: {
    AddToWishlistButton,
    PageHeader,
  },
  mixins: [BreadcrumbsManager],
  metaInfo() {
    return {
      title: Lang.get('labels.frontend.cart.cart'),
    };
  },
  data() {
    return {
      cart: {},
    };
  },
  created() {
    this.setBreadcrumbs([
      { name: Lang.get('labels.frontend.cart.cart') },
    ]);
  },
  mounted() {
    this.getCart();
    this.$ga.ecommerce.setAction('checkout', {
      step: 1,
    });
  },
  methods: {
    async getCart() {
      try {
        const { data } = await this.$store.dispatch('cart/get', { id: this.$store.getters['cart/id'] });
        this.cart = data;
        this.cart.coupon_code = this.cart.data.coupon ? this.cart.data.coupon.code : '';
      } catch (e) {
        this.cart = {};
      }
    },
    onFocus(item) {
      item.quantity = '';
    },
    onBlur(item) {
      if (item.quantity == 0 || item.quantity === '') {
        item.quantity = 1;
      }
      if (item.quantity % item.unit_factor === 0) {
      } else {
        item.quantity = this.round(item.quantity, item.unit_factor, 0);
      }
      this.onQtyUpdate(item);
    },
    round(number, increment, offset) {
      return Math.ceil((number - offset) / increment ) * increment + offset;
    },
    onCheckout() {
      if (this.cart.data.total_weight > 20000) {
        notify.message(this, { title: Lang.get('alerts.frontend.cart.overweight'), text: false }, 'danger');
      } else {
        router.push({name: 'checkout'});
      }
      _.forEach(this.cart.items, (item) => {
        this.onQtyUpdate((item));
      });
    },
    async onQtyUpdate(item) {
      if (item.quantity > 0 && item.quantity !== '') {
        item.isRefreshing = true;
        const {data} = await this.$store.dispatch('cart/update', {id: this.$store.getters['cart/id'], item})
          .catch((e) => {
            item.quantity = 1;
            this.onQtyUpdate(item);
            notify.errors(this, e);
          });
        this.cart = data;
        item.isRefreshing = false;
      }
    },
    async onQtyPlus(item) {
      item.isRefreshing = true;
      if (!this.quantity) {
        this.quantity = 0;
      }
      item.quantity = parseFloat(item.quantity) + item.unit_factor;
      try {
        const {data} = await this.$store.dispatch('cart/update', {id: this.$store.getters['cart/id'], item})
        this.cart = data;
      } catch (e) {
        item.quantity = parseFloat(item.quantity) - 1;
        notify.errors(this, e);
      }
      item.isRefreshing = false;
    },
    async onQtyMinus(item) {
      if (!this.quantity) {
        this.quantity = 1;
      }
      if (item.quantity === 1 || item.quantity == item.unit_factor) return;
      item.isRefreshing = true;
      item.quantity = parseFloat(item.quantity) - item.unit_factor;
      const { data } = await this.$store.dispatch('cart/update', { id: this.$store.getters['cart/id'], item })
        .catch((e) => {
          item.quantity = parseFloat(item.quantity) + item.unit_factor;
          notify.errors(this, e);
        });
      this.cart = data;
      item.isRefreshing = false;
    },
    async onRemove(item) {
      await this.$store.dispatch('cart/remove', { id: this.$store.getters['cart/id'], itemId: item.item_code });
      this.getCart();
      notify.success(this, { title: Lang.get('alerts.frontend.general.deleted_from_cart') });
    },
    async onApplyCouponCode() {
      console.log('applying coupon code', this.cart.coupon_code);
      try {
        await this.$store.dispatch('cart/apply_coupon', { id: this.$store.getters['cart/id'], couponCode: this.cart.coupon_code });
        this.getCart();
      } catch (e) {
        this.getCart();
        notify.errors(this, e);
      }
    },
  },
};
</script>
